export enum PhoneNumberValidationError {
    INVALID_COUNTRY_CODE = 1,
    TOO_SHORT = 2,
    TOO_LONG = 3,
    INVALID_LENGTH = 5,
}
